import React from 'react';
import { ILegalClient } from '../../../Interfaces/ILegalClient';
import { PurchaseContractMembers } from '../PurchaseContractMembers';

interface IProps {
  manager: ILegalClient[];
  setManager: (newValue: ILegalClient[]) => void;
  takenLegalClients: ILegalClient[];
  setTakenLegalClients: React.Dispatch<React.SetStateAction<ILegalClient[]>>;
}

export const RealEstateManager: React.FC<IProps> = ({
  manager,
  setManager,
  takenLegalClients,
  setTakenLegalClients,
}) => (
  <PurchaseContractMembers
    title='Verwalter/inn'
    subtitle='Falls das Wohn- oder Teileigentum einen/eine Verwalter/inn hat, so erfassen Sie diese Person bitte.'
    limit={1}
    members={manager}
    setMembers={setManager}
    takenLegalClients={takenLegalClients}
    setTakenLegalClients={setTakenLegalClients}
  />
);
